<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                     <v-btn dark icon title="Back to Settings" @click="$router.push('/settings')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="settings" pageId="calendar-periods" color="white"></help-link>
                    <v-btn v-if="hasAddRights&&cutoff_setting" fab dark small color="primary" title="Add Calendar Period" @click="addFiscalPeriod">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                </v-toolbar>
            </v-card>

            <v-alert v-if="!loading&&!cutoff_setting" :value="true" color="error" icon="error" outline class="mt-8">
                Cutoff settings has not been setup yet. <span class="font-weight-bold clickable" @click="$router.push(`/settings/cutoff`)"><u>Click here</u></span> to update. You can also navigate to Company > Settings > Cutoff.
            </v-alert>

            <v-card class="elevation-1 mt-5"> 
                <v-toolbar flat height="35px">
                    <span class="font-weight-bold">Calendar Periods</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table
                    :headers="isMobile?headers_mobile:headers"
                    :items="fiscal_periods"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                    >
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" title="Click to View/Edit" class="clickable">
                            <td>{{props.item.fiscalYear}}</td>
                            <td v-if="!isMobile">{{props.item.fiscalStartDate|moment('MMMM D, YYYY')}}</td>
                            <td v-if="!isMobile">{{props.item.fiscalEndDate|moment('MMMM D, YYYY')}}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.fiscalPeriodStatus)">{{commonfn.getStatusDescription(props.item.fiscalPeriodStatus)}}</b>
                            </td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.recordStatus)">{{commonfn.getStatusDescription(props.item.recordStatus)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
            
        </v-flex>
        <v-dialog v-model="dialogAddEdit" persistent width="500">
            <add-edit ref="addEditRef" :dialogAddEdit.sync="dialogAddEdit" @send="getFiscalPeriods"></add-edit>
        </v-dialog>
    </v-layout> 
</template>

<script>

import commonfn from '@/common/functions'   //for refactor
import fiscalPeriodsApi from '@/api/fiscalperiods'
import rowsPerPageItems from '@/constants/rows-per-page'
import { hasAddRights } from '@/helpers/access-permissions'
import { getSort, getRowsPerPage, updateRowsPerPage, updateSort } from '@/helpers/user-prefs'

export default {     
    name: 'CalendarPeriods',
    metaInfo: {
        title: 'Calendar Periods',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Calendar Periods' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'add-edit' : () => import('@/components/FiscalPeriods/FiscalPeriodAddEdit')
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            commonfn,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            error: false,
            errorMessage: '',
            loading: false,
            headers: [
                {text: 'Calendar Year',align: 'left',value: 'fiscalYear',width: '20%', sortable:true},
                {text: 'Start Date',align: 'left',value: 'fiscalStartDate',width: '20%', sortable:true},
                {text: 'End Date',align: 'left',value: 'fiscalEndDate',width: '20%', sortable:true},
                {text: 'Calendar Period Status',align: 'left',value: 'fiscalPeriodStatus',width: '20%', sortable:true},
                {text: 'Record Status',align: 'left',value: 'recordStatus',width: '20%', sortable:true},
            ],
            headers_mobile: [
                {text: 'Year',align: 'left',value: 'fiscalYear',width: '20%', sortable:true},
                {text: 'Calendar',align: 'left',value: 'fiscalPeriodStatus',width: '20%', sortable:true},
                {text: 'Record',align: 'left',value: 'recordStatus',width: '20%', sortable:true},
            ],
            dialogAddEdit: false,
            fiscal_periods: [],
            cutoff_setting: null
        }
    },
    methods: {   
        viewDetails(data) {
            this.$router.push(`calendarperiods/${data.fiscalPeriodId}`)
        },
        addFiscalPeriod() {
            this.$refs.addEditRef.setAdd()
            this.dialogAddEdit = true
        },  
        async getFiscalPeriods() {
            try {
                this.loading = true
                const response = await fiscalPeriodsApi.getByCompany() 
                if (response && response.status==200) {
                    this.cutoff_setting = response.data.cutOffSettings
                    this.fiscal_periods = response.data.items.reverse()
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Calendar Periods'
        })

        this.getFiscalPeriods()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        hasAddRights() {
            return hasAddRights(this.$router.currentRoute.path)
        },
        page_title_class() {
            if (this.isMobile) return 'margin:18px 0px 0px 22px;'
            else return 'margin:5px 0px 0px 30px;'
        },
    }
}
</script>